import { DEFAULT_SITE_STYLE } from './siteCmsTypes';
import { CMS_PALETTES, paletteFor, siteBackgroundSwatches } from './siteCmsPalettes';
import { DEFAULT_TECH_STYLE, normalizeTechStyle } from './techPageStyle';

export { DEFAULT_SITE_STYLE, paletteFor };
export const SITE_PALETTES = CMS_PALETTES;

export const normalizeSiteStyle = value => {
  const incoming = value && typeof value === 'object' ? value : {};
  const buttons = incoming.buttons && typeof incoming.buttons === 'object' ? incoming.buttons : {};
  const cards = incoming.cards && typeof incoming.cards === 'object' ? incoming.cards : {};
  const paletteId = CMS_PALETTES.some(item => item.id === incoming.paletteId) ? incoming.paletteId : DEFAULT_SITE_STYLE.paletteId;
  const palette = CMS_PALETTES.find(item => item.id === paletteId) || paletteFor({ paletteId });
  const requestedBackground = String(incoming.siteBackground || '').toUpperCase();
  const background = siteBackgroundSwatches(palette).find(swatch => swatch.hex.toUpperCase() === requestedBackground)?.hex;
  return {
    version: 1,
    paletteId,
    siteBackground: background,
    typography: ['modern', 'clean', 'editorial'].includes(incoming.typography) ? incoming.typography : DEFAULT_SITE_STYLE.typography,
    buttons: {
      style: ['solid', 'outline', 'soft'].includes(buttons.style) ? buttons.style : DEFAULT_SITE_STYLE.buttons.style,
      shape: ['square', 'rounded', 'pill'].includes(buttons.shape) ? buttons.shape : DEFAULT_SITE_STYLE.buttons.shape,
      size: ['compact', 'regular', 'large'].includes(buttons.size) ? buttons.size : DEFAULT_SITE_STYLE.buttons.size,
    },
    cards: {
      shape: ['square', 'rounded', 'soft'].includes(cards.shape) ? cards.shape : DEFAULT_SITE_STYLE.cards.shape,
      frame: ['none', 'hairline', 'shadow'].includes(cards.frame) ? cards.frame : DEFAULT_SITE_STYLE.cards.frame,
      motion: ['none', 'lift', 'glow'].includes(cards.motion) ? cards.motion : DEFAULT_SITE_STYLE.cards.motion,
    },
    motion: ['quiet', 'smooth', 'dynamic'].includes(incoming.motion) ? incoming.motion : DEFAULT_SITE_STYLE.motion,
    tech: normalizeTechStyle(incoming.tech || DEFAULT_TECH_STYLE),
  };
};
